import { Btn, Eyebrow, Icon, linkStyle } from '../components/primitives';
import { useOpenPublisherModal } from '../components/publisher-modal';
import questBoundLogo from '../assets/qb-logo.png';
import heroItemCreate from '../assets/hero-item-create.png';

export const Nav = () => (
  <nav
    className="qb-nav"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '18px 40px',
      borderBottom: '1px solid var(--qb-border-soft)',
      background: 'rgba(20,19,18,0.78)',
      backdropFilter: 'blur(12px)',
      position: 'sticky',
      top: 0,
      zIndex: 50,
    }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <img src={questBoundLogo} style={{ height: 30 }} alt="Quest Bound" />
      <span
        className="qb-nav-brand-text"
        style={{
          fontFamily: 'var(--qb-font-display)',
          fontSize: 16,
          letterSpacing: '0.06em',
        }}>
        QUEST BOUND
      </span>
    </div>
    <div
      className="qb-nav-links"
      style={{
        display: 'flex',
        gap: 32,
        fontFamily: 'var(--qb-font-display)',
        textTransform: 'uppercase',
        fontSize: 11,
        letterSpacing: '0.14em',
        color: 'var(--qb-fg-muted)',
      }}>
      <a className="qb-nav-link" href="#build" style={linkStyle}>Build</a>
      <a className="qb-nav-link" href="#publish" style={linkStyle}>Publish</a>
      <a className="qb-nav-link" href="#play" style={linkStyle}>Play</a>
      <a className="qb-nav-link" href="#measure" style={linkStyle}>Measure</a>
      <a className="qb-nav-link" href="#pricing" style={linkStyle}>Pricing</a>
      <a className="qb-nav-link" href="#faq" style={linkStyle}>FAQ</a>
    </div>
    <div style={{ display: 'flex', gap: 10 }}>
      <Btn size="sm" href="https://app.questbound.com">Start Building</Btn>
    </div>
  </nav>
);

const Trust = ({ k, v }: { k: string; v: string }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    <span
      style={{
        fontFamily: 'var(--qb-font-display)',
        textTransform: 'uppercase',
        fontSize: 9,
        letterSpacing: '0.16em',
        color: 'var(--qb-fg-subtle)',
      }}>
      {k}
    </span>
    <span
      style={{
        color: 'var(--qb-fg)',
        fontFamily: 'var(--qb-font-display)',
        fontSize: 13,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
      }}>
      {v}
    </span>
  </div>
);

const HeroArt = () => {
  const CARD_W = 460;
  const CARD_H = 300;
  const baseFrame = {
    position: 'absolute' as const,
    width: CARD_W,
    height: CARD_H,
    overflow: 'hidden' as const,
    boxShadow: '10px 10px 0 var(--qb-ink-900)',
    border: '1px solid var(--qb-border-strong)',
    borderRadius: 6,
    background: 'var(--qb-ink-700)',
  };

  return (
    <div className="qb-hero-art" style={{ position: 'relative', height: 760, marginTop: -20 }}>
      {/* CARD 01 — storefront */}
      <div
        style={{
          ...baseFrame,
          top: 0,
          left: 40,
          transform: 'rotate(-4deg)',
          zIndex: 1,
          background: 'var(--qb-cream-50)',
          color: 'var(--qb-ink-800)',
          border: '3px solid var(--qb-ink-900)',
        }}>
        <div
          style={{
            height: 180,
            background: 'linear-gradient(160deg, #3d1706, #973c14)',
            borderBottom: '3px solid var(--qb-ink-900)',
            display: 'flex',
            alignItems: 'flex-end',
            padding: 18,
            color: '#fbf5e9',
          }}>
          <div>
            <div
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 11,
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                opacity: 0.8,
              }}>
              NINE-CROWNS PRESS
            </div>
            <div
              className="qb-storefront-title"
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 32,
                letterSpacing: '0.02em',
                textTransform: 'uppercase',
                lineHeight: 0.95,
                marginTop: 6,
              }}>
              Wayfarers of<br />the Outer Reach
            </div>
          </div>
        </div>
        <div style={{ padding: '16px 20px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 14,
            }}>
            <div
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 12,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--qb-orange-700)',
              }}>
              CORE RULEBOOK · 2.1
            </div>
            <div style={{ fontFamily: 'var(--qb-font-display)', fontSize: 22 }}>$24</div>
          </div>
          <div
            style={{
              background: 'var(--qb-orange-500)',
              color: '#fff',
              padding: '12px 0',
              fontFamily: 'var(--qb-font-display)',
              fontSize: 13,
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              textAlign: 'center',
              border: '2px solid var(--qb-ink-900)',
            }}>
            Add to Shelf
          </div>
        </div>
      </div>

      {/* CARD 02 — item editor */}
      <div
        style={{
          ...baseFrame,
          top: 200,
          left: -10,
          transform: 'rotate(2.5deg)',
          zIndex: 2,
        }}>
        <img
          src={heroItemCreate}
          alt="Quest Bound item editor — Potion of Healing"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'top left',
            display: 'block',
          }}
        />
      </div>

      {/* CARD 03 — sales dashboard */}
      <div
        style={{
          ...baseFrame,
          top: 430,
          left: 70,
          transform: 'rotate(-3deg)',
          zIndex: 3,
          background: 'var(--qb-ink-800)',
          padding: 0,
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '12px 18px',
            borderBottom: '1px solid var(--qb-border-soft)',
            background: 'var(--qb-ink-900)',
          }}>
          <div style={{ display: 'flex', gap: 6 }}>
            <span style={{ width: 9, height: 9, borderRadius: '50%', background: '#56524f' }} />
            <span style={{ width: 9, height: 9, borderRadius: '50%', background: '#56524f' }} />
            <span style={{ width: 9, height: 9, borderRadius: '50%', background: 'var(--qb-orange-500)' }} />
          </div>
          <span
            style={{
              fontFamily: 'var(--qb-font-display)',
              fontSize: 11,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'var(--qb-fg-muted)',
              marginLeft: 8,
            }}>
            Publisher Dashboard
          </span>
          <span
            style={{
              marginLeft: 'auto',
              fontFamily: 'var(--qb-font-display)',
              fontSize: 9,
              letterSpacing: '0.16em',
              color: 'var(--qb-orange-400)',
            }}>
            LIVE
          </span>
        </div>
        <div
          style={{
            padding: '20px 24px',
            display: 'grid',
            gridTemplateColumns: '1.1fr 1fr',
            gap: 18,
            height: 'calc(100% - 44px)',
            boxSizing: 'border-box',
          }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 10,
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: 'var(--qb-fg-subtle)',
              }}>
              LAST 7 DAYS
            </div>
            <div
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 56,
                color: 'var(--qb-fg)',
                margin: '4px 0 8px',
                fontVariantNumeric: 'tabular-nums',
                lineHeight: 1,
              }}>
              $1,284
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontFamily: 'var(--qb-font-display)',
                fontSize: 11,
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: 'var(--qb-orange-400)',
              }}>
              <Icon s={14} d="M5 19V5m0 0-6 6m6-6 6 6" /> +38% · 64 sales
            </div>
            <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 6 }}>
              {[
                ['Wayfarers core', '$612'],
                ['Outer Reach mod', '$398'],
                ['Bestiary I', '$274'],
              ].map(([label, val]) => (
                <div
                  key={label}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontFamily: 'var(--qb-font-body)',
                    fontSize: 12,
                    color: 'var(--qb-fg-muted)',
                    borderBottom: '1px dashed var(--qb-border-soft)',
                    paddingBottom: 4,
                  }}>
                  <span>{label}</span>
                  <span style={{ color: 'var(--qb-fg)', fontVariantNumeric: 'tabular-nums' }}>{val}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <svg width="100%" height="170" viewBox="0 0 200 170" preserveAspectRatio="none">
              <polyline
                points="0,140 14,118 28,128 42,96 56,108 70,72 84,86 98,58 112,68 126,40 140,52 154,28 168,40 182,16 196,28"
                fill="none"
                stroke="var(--qb-orange-500)"
                strokeWidth="2.5"
                strokeLinecap="square"
                strokeLinejoin="miter"
              />
              <polyline
                points="0,140 14,118 28,128 42,96 56,108 70,72 84,86 98,58 112,68 126,40 140,52 154,28 168,40 182,16 196,28 196,170 0,170"
                fill="var(--qb-orange-900)"
                opacity=".4"
                stroke="none"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

const PipelineRibbon = () => {
  const steps = [
    { n: '01', t: 'BUILD', s: 'Engine' },
    { n: '02', t: 'PUBLISH', s: 'Storefront' },
    { n: '03', t: 'PLAY', s: 'Hosted Application' },
    { n: '04', t: 'MEASURE', s: 'Dashboard' },
  ];
  return (
    <div
      className="qb-pipeline-ribbon"
      style={{
        position: 'relative',
        zIndex: 2,
        maxWidth: 1280,
        margin: '72px auto 0',
        border: '1px solid var(--qb-border-strong)',
        background: 'rgba(29,28,28,0.7)',
        backdropFilter: 'blur(8px)',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
      }}>
      {steps.map((st, i) => (
        <a
          href={`#${st.t.toLowerCase()}`}
          key={st.n}
          style={{
            ...linkStyle,
            padding: '20px 28px',
            borderRight: i < 3 ? '1px solid var(--qb-border-strong)' : 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            position: 'relative',
            transition: 'background 200ms var(--qb-ease-standard)',
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(230,106,60,0.06)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.background = 'transparent';
          }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 11,
                letterSpacing: '0.16em',
                color: 'var(--qb-orange-500)',
              }}>
              {st.n}
            </span>
            <span
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 18,
                letterSpacing: '0.08em',
                color: 'var(--qb-fg)',
              }}>
              {st.t}
            </span>
          </div>
          <span
            style={{
              fontFamily: 'var(--qb-font-body)',
              fontSize: 13,
              color: 'var(--qb-fg-muted)',
              marginLeft: 30,
            }}>
            {st.s}
          </span>
          {i < 3 && (
            <Icon
              s={14}
              d="M5 12h14m0 0-5-5m5 5-5 5"
              style={{
                position: 'absolute',
                right: -7,
                top: 'calc(50% - 7px)',
                color: 'var(--qb-fg-subtle)',
                background: 'var(--qb-ink-700)',
                padding: 0,
              }}
              className="qb-pipeline-arrow"
            />
          )}
        </a>
      ))}
    </div>
  );
};

export const Hero = () => {
  const openPublisherModal = useOpenPublisherModal();
  return (
  <section
    className="qb-hero-section"
    style={{
      position: 'relative',
      padding: '84px 40px 100px',
      borderBottom: '1px solid var(--qb-border-soft)',
      overflow: 'hidden',
      background: 'var(--qb-ink-700)',
    }}>
    <div
      style={{
        position: 'absolute',
        inset: '-10% -5%',
        background:
          'radial-gradient(ellipse at 70% 35%, var(--qb-orange-900) 0%, transparent 55%), radial-gradient(ellipse at 15% 85%, #2b1d10 0%, transparent 60%)',
        animation: 'qbDrift 14s ease-in-out infinite',
        pointerEvents: 'none',
      }}
    />
    <div className="qb-grain" style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />

    <div
      className="qb-hero-grid"
      style={{
        position: 'relative',
        zIndex: 2,
        maxWidth: 1280,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '1fr 1.05fr',
        gap: 56,
        alignItems: 'center',
      }}>
      <div>
        <Eyebrow>★ THE TABLETOP RPG PLATFORM</Eyebrow>
        <h1
          className="qb-hero-h1"
          style={{
            fontFamily: 'var(--qb-font-display)',
            textTransform: 'uppercase',
            fontSize: 84,
            lineHeight: 0.94,
            letterSpacing: '-0.015em',
            margin: '20px 0 8px',
            textWrap: 'balance',
          }}>
          Build it.<br />
          Sell it.<br />
          <span style={{ color: 'var(--qb-orange-500)' }}>Play it.</span>
        </h1>
        <p
          className="qb-hero-lead"
          style={{
            fontFamily: 'var(--qb-font-body)',
            fontSize: 21,
            lineHeight: 1.5,
            color: 'var(--qb-fg-muted)',
            fontStyle: 'italic',
            maxWidth: 540,
            margin: '22px 0 30px',
          }}>
          Quest Bound is the end-to-end platform for digital tabletop RPGs. Author your ruleset in
          the engine, launch a storefront, ship a playable app, and watch sales come in — all from
          one place.
        </p>
        <div className="qb-hero-buttons" style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
          <Btn size="lg" href="https://app.questbound.com">Start Building — Free</Btn>
          <Btn kind="secondary" size="lg" href="#" onClick={openPublisherModal}>
            Become a Publisher →
          </Btn>
        </div>
        <div
          className="qb-hero-trust"
          style={{
            marginTop: 36,
            display: 'flex',
            gap: 36,
            flexWrap: 'wrap',
            color: 'var(--qb-fg-subtle)',
            fontFamily: 'var(--qb-font-body)',
            fontSize: 13,
          }}>
          <Trust k="ENGINE" v="Free & open source" />
          <Trust k="PUBLISHING" v="In Beta" />
          <Trust k="PLAYS WITH" v="Any VTT or Physical Table" />
        </div>
      </div>

      <HeroArt />
    </div>

    <PipelineRibbon />
  </section>
  );
};
